/*
 * Broadcast Theme
 *
 * CORREÇÃO: A app Swatch King muda a URL (?variant=...) ao selecionar uma
 * variante diferente, mas usa history.pushState() — que NÃO dispara o evento
 * "popstate" que o tema escuta para atualizar o preço mostrado no ecrã.
 * O carrinho fica sempre correto (porque lê o formulário/URL no momento do
 * clique em "Adicionar ao carrinho"), mas o preço visível na página não
 * atualiza até recarregares.
 *
 * Este script "intercepta" pushState/replaceState e força uma verificação
 * do preço da variante atual sempre que a URL muda — sem precisares de
 * recarregar a página.
 */
(function () {
  // --- 1. Fazer com que pushState/replaceState avisem o resto da página ---
  var originalPushState = history.pushState;
  var originalReplaceState = history.replaceState;

  function announceUrlChange() {
    window.dispatchEvent(new Event('cc:locationchange'));
  }

  history.pushState = function () {
    originalPushState.apply(this, arguments);
    announceUrlChange();
  };
  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    announceUrlChange();
  };
  window.addEventListener('popstate', announceUrlChange);

  // --- 2. Formatar dinheiro tal como o resto do tema (usa Shopify.formatMoney se existir) ---
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme && theme.moneyFormat) {
      return Shopify.formatMoney(cents, theme.moneyFormat);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' lei';
  }

  // --- 3. Quando a URL muda, buscar os dados reais da variante e atualizar o preço ---
  function updatePriceFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId) return;

    fetch(window.location.pathname + '.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (product) {
        var variant = product.variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (!variant) return;

        var hasSale = variant.compare_at_price && variant.compare_at_price > variant.price;

        // Preço atual
        document.querySelectorAll('[data-product-price]').forEach(function (el) {
          el.textContent = formatMoney(variant.price);
        });

        // Preço riscado (comparado)
        document.querySelectorAll('[data-compare-price]').forEach(function (el) {
          if (hasSale) {
            el.textContent = formatMoney(variant.compare_at_price);
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });

        // Badge de desconto (bloco "REDUCERE X%")
        document.querySelectorAll('[data-price-off]').forEach(function (el) {
          el.style.display = hasSale ? '' : 'none';
        });
        document.querySelectorAll('[data-price-off-amount]').forEach(function (el) {
          if (hasSale) {
            var pct = Math.round(
              ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
            );
            el.textContent = pct + '%';
          }
        });

        // Preço unitário, se existir
        if (variant.unit_price) {
          document.querySelectorAll('[data-product-unit-price]').forEach(function (el) {
            el.textContent = formatMoney(variant.unit_price);
          });
        }
      })
      .catch(function (err) {
        console.warn('Não foi possível atualizar o preço a partir da URL:', err);
      });
  }

  window.addEventListener('cc:locationchange', updatePriceFromUrl);

  // Também correr uma vez ao clicar em qualquer botão de variante da Swatch King,
  // como rede de segurança extra (caso a app não mude a URL em todos os casos).
  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-variant-id], .swatch, .variant-swatch, button');
    if (target) {
      // pequeno atraso para dar tempo à Swatch King de atualizar a URL primeiro
      setTimeout(updatePriceFromUrl, 150);
    }
  });
})();
